import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ThemeProvider } from '@mui/material';

import { useUser, useUserActions } from '@mopla/business-logic';
import { passengerThemeV2 } from '@mopla/mui';
import { DTicketPageLayout } from '@mopla/ui';

import { usePassengerAppNavigate } from '../../../hooks';

import { ManageBillingAddressForm } from './ManageBillingAddressForm';
import { ManageBillingAddressFormSkeleton } from './ManageBillingAddressFormSkeleton';

export const ManageBillingAddress = () => {
	const { t } = useTranslation('manageBillingAddress');
	const { navigateToDownloadInvoices } = usePassengerAppNavigate();
	const { isLoading } = useUser();
	const { fetchUser } = useUserActions();

	useEffect(() => {
		fetchUser();
	}, [fetchUser]);

	return (
		<ThemeProvider theme={passengerThemeV2}>
			<DTicketPageLayout
				title={t('page_title')}
				onBack={navigateToDownloadInvoices}
				scrollable={true}
				dataTestId="manage-billing-address-page"
			>
				{isLoading ? (
					<ManageBillingAddressFormSkeleton />
				) : (
					<ManageBillingAddressForm />
				)}
			</DTicketPageLayout>
		</ThemeProvider>
	);
};
